const getElSize = (selector, property = 'height') => {
  const el = document.querySelector(selector)
  if (!el) return 0
  if (property === 'width') {
    return el.offsetWidth
  } else if (property === 'height') {
    return el.offsetHeight
  }
}

export { getElSize }

const getScrollbarWidth = () => {
  // Reliable method: create a temporary element with overflow to measure the scrollbar
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar'; // Necessary for IE
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculate the scrollbar width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Clean up
  outer.parentNode.removeChild(outer);

  // Update the CSS variable
  document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  return scrollbarWidth;
}

export { getScrollbarWidth }

const lockBodyScroll = (lock) => {
  if (lock) {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('prevent-lenis-scroll');
    document.body.style.paddingRight = `${getScrollbarWidth()}px`;
  } else {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.classList.remove('prevent-lenis-scroll');
    document.body.style.paddingRight = '';
  }
}

export { lockBodyScroll }